import { styled } from "../../../../styles";

export const TitleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
});

export const NewDataCOntainer = styled("div", {
  marginLeft: "5px",
  color: "$gray-80",

  fontFamily: "$nunito",
  fontWeight: "600px",
  fontSize: "16px",
  lineHeight: "34px",
});

export const TableSettingsContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  marginTop: "3px",
  marginLeft: "2px",
  borderRadius: "50%",
  cursor: "pointer",

  height: "30px",
  width: "30px",

  "&:hover": {
    backgroundColor: "rgba(147, 147, 147, 0.12)",
  },

  "&:focus-visible": {
    outline: "none !important",
    border: "2px solid $primary-30 !important",
  },
});
